import { Chip as MuiChip } from '@mui/material'
import { useEffect, useState } from 'react'

interface ChipProps {
  children: string
  icon?: React.ReactElement
  onClick?: () => void
  variant:
    | 'amber'
    | 'blue'
    | 'brown'
    | 'cyan'
    | 'gold'
    | 'gray'
    | 'green'
    | 'indigo'
    | 'lime'
    | 'magenta'
    | 'maroon'
    | 'mint'
    | 'navy'
    | 'olive'
    | 'orange'
    | 'peach'
    | 'pink'
    | 'plum'
    | 'purple'
    | 'red'
    | 'silver'
    | 'teal'
    | 'turquoise'
    | 'violet'
    | 'yellow'
}

// Standard Spud ERP Chip. The purpose of this component is to ensure every chip throughout the application
// is consistent.
export default function Chip({ children, icon, onClick, variant }: ChipProps) {
  const [backgroundColor, setBackgroundColor] = useState<string>('')
  const [color, setColor] = useState<string>('')

  useEffect(() => {
    if (variant === 'red') {
      setBackgroundColor('#ffe9ea')
      setColor('#ff8185')
    } else if (variant === 'green') {
      setBackgroundColor('#eaf9e0')
      setColor('#56ca00')
    } else if (variant === 'blue') {
      setBackgroundColor('#e3f6ff')
      setColor('#26b6ff')
    } else if (variant === 'yellow') {
      setBackgroundColor('#fff6e0')
      setColor('#ffb400')
    } else if (variant === 'purple') {
      setBackgroundColor('#f2eaff')
      setColor('#9155fd')
    } else if (variant === 'gray') {
      setBackgroundColor('#f1f1f2')
      setColor('#9d9fa4')
    } else if (variant === 'orange') {
      setBackgroundColor('#ffedd5')
      setColor('#ff8a00')
    } else if (variant === 'pink') {
      setBackgroundColor('#ffe4e9')
      setColor('#ff66b2')
    } else if (variant === 'teal') {
      setBackgroundColor('#e0f7f7')
      setColor('#00c7b1')
    } else if (variant === 'brown') {
      setBackgroundColor('#f3e7e0')
      setColor('#a97c50')
    } else if (variant === 'lime') {
      setBackgroundColor('#f2ffd5')
      setColor('#b2d500')
    } else if (variant === 'indigo') {
      setBackgroundColor('#e8eaf6')
      setColor('#3f51b5')
    } else if (variant === 'cyan') {
      setBackgroundColor('#e0f7fa')
      setColor('#00bcd4')
    } else if (variant === 'amber') {
      setBackgroundColor('#fff8e1')
      setColor('#ffc107')
    } else if (variant === 'violet') {
      setBackgroundColor('#f3e5f5')
      setColor('#ab47bc')
    } else if (variant === 'olive') {
      setBackgroundColor('#f4f4e3')
      setColor('#808000')
    } else if (variant === 'navy') {
      setBackgroundColor('#e5eaf5')
      setColor('#001f3f')
    } else if (variant === 'magenta') {
      setBackgroundColor('#ffe1f0')
      setColor('#ff00ff')
    } else if (variant === 'maroon') {
      setBackgroundColor('#f0e0e6')
      setColor('#800000')
    } else if (variant === 'turquoise') {
      setBackgroundColor('#e0f7f9')
      setColor('#40e0d0')
    } else if (variant === 'gold') {
      setBackgroundColor('#fff9e0')
      setColor('#ffd700')
    } else if (variant === 'silver') {
      setBackgroundColor('#f0f0f0')
      setColor('#c0c0c0')
    } else if (variant === 'peach') {
      setBackgroundColor('#ffebe1')
      setColor('#ffab91')
    } else if (variant === 'mint') {
      setBackgroundColor('#e0fff5')
      setColor('#98ff98')
    } else if (variant === 'plum') {
      setBackgroundColor('#f5e0f0')
      setColor('#dda0dd')
    }
  }, [variant])

  return (
    <MuiChip
      label={children}
      icon={icon}
      onClick={onClick}
      sx={{ height: '20px', backgroundColor, color, m: 0.25 }}
      variant='filled'
    />
  )
}
